<template>
  <font-awesome-icon :icon="icon" :class="clazz"/>
</template>

<script>
export default {
  props: {
    value: Boolean
  },
  computed: {
    icon(){
      return this.value ? 'check' : 'times'
    },
    clazz(){
      return this.value ? 'text-success' : 'text-muted'
    }
  }
}
</script>
